import { slotDefinition } from "../configs/slotDefinition.config.js";

export async function spinning(scope, ctx) {
    const { hud, reels, gameLogic, data, audio } = ctx;

    hud.setSpinningState();
    hud.resetWin();
    hud.setBalance(gameLogic.balance - gameLogic.bet);

    const spinTimeline = reels.spin(data.spinType);
    scope.defer(() => { if (spinTimeline) spinTimeline.kill(); });

    let isSkipped = false;

    scope.on(hud.onStop, () => {
        if (spinTimeline && spinTimeline.isActive()) {
            spinTimeline.progress(1);
            isSkipped = true;
        }
    });

    const result = await gameLogic.spin();

    const scatterCount = result?.matrix?.getSymbolsCount?.(slotDefinition.scatter) ?? 0;
    const wildCount = result?.matrix?.getSymbolsCount?.(slotDefinition.wild) ?? 0;

    if (scatterCount >= 3) audio.playSfx("sfx_scatter_trigger");
    if (wildCount > 0) audio.playSfx("sfx_wild_land");

    if (spinTimeline) {
        await new Promise((resolve) => {
            if (!spinTimeline.isActive()) return resolve();
            spinTimeline.eventCallback("onComplete", resolve);
        });
    }

    return { result, quickStop: isSkipped };
}
